import React from 'react';
import { AnimatedSection } from '../shared/AnimatedSection';
import { GlowCard } from '../shared/GlowCard';
import { Sign } from '../../data/signs';
interface SignProblemaProps {
  sign: Sign;
}
export function SignProblema({
  sign
}: SignProblemaProps) {
  const {
    problemaTitle,
    problemaSubtitle,
    problemas
  } = sign.content;
  return <section className="py-20 px-6 bg-transparent" data-id="element-310">
      <div className="container mx-auto max-w-5xl" data-id="element-311">
        <AnimatedSection data-id="element-312">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-center text-white mb-4" data-id="element-313">
            {problemaTitle}
          </h2>
          <h3 className="text-xl md:text-2xl font-serif text-center mb-12 italic" style={{
          color: sign.colors.accent
        }} data-id="element-314">
            {problemaSubtitle}
          </h3>
        </AnimatedSection>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-315">
          {problemas.map((problema, index) => <AnimatedSection key={index} delay={0.2 + index * 0.1} data-id="element-316">
              <GlowCard glowColor={sign.colors.primary} className="h-full" data-id="element-317">
                <p className="text-gray-200 leading-relaxed" data-id="element-318">{problema}</p>
              </GlowCard>
            </AnimatedSection>)}
        </div>
      </div>
    </section>;
}